/* ==========================================================================
   ATELIER WISHLIST TOAST + fly-to-icon + reverse-flight Undo  (global; via header)
   Replaces SWishlist's toast/drawer with our own reward on its
   swishlist:st-added-product / swishlist:st-deleted-product events (window).

   MODEL (robust, does NOT fight SWishlist's commit):
   - SWishlist still commits add/remove on the heart click. We show the reward
     OPTIMISTICALLY on click so it feels instant.
   - ADD: pulse + optimistic fill + heart flies UP to the header icon; on LAND it
     "commits" visually (badge +1) and the toast drops top-right with an Undo.
   - UNDO / un-heart: a heart flies from the icon back DOWN to the card and only
     un-fills it on landing; Undo also calls SWishlist.removeFromWishlist().
   NEVER restyles the heart button. The mid-flight rewind is intentionally omitted
   (it races SWishlist's async commit - see memory).
   ========================================================================== */
(function () {
  "use strict";
  try { window.__awtLoaded = true; } catch (e) {}
  var HEART = '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.8-9.5-9.1C.9 8.2 3 4.5 6.7 4.5c2.2 0 3.9 1.2 5.3 3 1.4-1.8 3.1-3 5.3-3 3.7 0 5.8 3.7 4.2 7.4C19.5 16.2 12 21 12 21z"/></svg>';
  var count = 0, wrap = null, timer = null, lastFire = 0, lastOp = null, lastBadgeOp = 0, OFF = 14;

  function txt(el) { return el ? el.textContent.trim() : ""; }
  function bgImg(el) { try { return getComputedStyle(el).backgroundImage; } catch (e) { return ""; } }
  function navLink() { return document.getElementById("awtNavLink"); }
  function iconVisible(el) { return !!(el && el.offsetParent !== null && el.getBoundingClientRect().width > 0); }
  function centerOf(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2, r: r }; }
  function inView(r) { return r.bottom > 60 && r.top < window.innerHeight - 8 && r.width > 0; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  function whenReady(cb) {
    if (window.SWishlist && typeof window.SWishlist.getList === "function") return cb();
    document.addEventListener("SWishlistReady", function () { cb(); }, { once: true });
    var n = 0, iv = setInterval(function () {
      if (window.SWishlist && window.SWishlist.getList) { clearInterval(iv); cb(); } else if (++n > 40) clearInterval(iv);
    }, 150);
  }

  /* ---------- header badge ---------- */
  function badgeEl() { return document.getElementById("awtNavBadge"); }
  function setBadge(n) {
    count = n < 0 ? 0 : n;
    var b = badgeEl(); if (!b) return;
    if (count > 0) { b.textContent = count > 99 ? "99+" : count; b.hidden = false; } else b.hidden = true;
  }
  function bumpBadge(delta) {
    lastBadgeOp = Date.now();
    setBadge(count + delta);
    var link = navLink();
    if (link) { link.classList.remove("awt-iconbump"); void link.offsetWidth; link.classList.add("awt-iconbump"); }
    if (delta > 0) { var b = badgeEl(); if (b) { b.classList.remove("awt-pop"); void b.offsetWidth; b.classList.add("awt-pop"); } }
  }
  function initBadge() {
    try {
      Promise.resolve(window.SWishlist.getList()).then(function (l) {
        var a = Array.isArray(l) ? l : (l && l.products) || []; setBadge(a.length);
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- product info from the tapped heart ---------- */
  function productFromHeart(btn) {
    var p = { title: "", img: "", fin: "", swatchBg: "", handle: btn.getAttribute("data-handle") || "" };
    var card = btn.closest(".pc");
    if (card) {
      p.title = txt(card.querySelector(".pc-tt"));
      var im = card.querySelector(".pc-im img"); if (im) p.img = im.currentSrc || im.src || "";
      var nm = card.querySelector(".pc-finsel .nm"), sw = card.querySelector(".pc-finsel .sw");
      if (nm) { p.fin = txt(nm); if (sw) p.swatchBg = bgImg(sw); }
      else { var on = card.querySelector(".pc-fin.on"); if (on) { p.fin = on.getAttribute("title") || ""; p.swatchBg = bgImg(on); } }
      return p;
    }
    var pdp = document.querySelector(".atelier-pdp");
    if (pdp) {
      p.title = txt(pdp.querySelector("h1, .product-title, .atelier-pt"));
      var pim = pdp.querySelector(".keen-slider__slide img, .product__media img, img");
      if (pim) p.img = pim.currentSrc || pim.src || "";
    }
    return p;
  }

  /* ---------- pulse ring (from the button; button untouched) ---------- */
  function firePulse(x, y) {
    var r = document.createElement("span"); r.className = "awt-pulse";
    r.style.left = x + "px"; r.style.top = y + "px"; r.style.width = "46px"; r.style.height = "46px";
    document.body.appendChild(r); void r.offsetWidth; r.classList.add("go");
    r.addEventListener("animationend", function () { r.remove(); }, { once: true });
  }

  /* ---------- generic arc flight ---------- */
  function canFly() { return typeof document.createElement("span").animate === "function"; }
  function flyArc(sx, sy, ex, ey, dur, onLand) {
    if (!canFly()) { if (onLand) onLand(); return; }
    var dx = ex - sx, dy = ey - sy, arc = Math.min(150, Math.abs(dx) * 0.28 + Math.abs(dy) * 0.22 + 55);
    var mx = sx + dx * 0.5, my = sy + dy * 0.5 - arc;
    var f = document.createElement("span"); f.className = "awt-fly"; f.innerHTML = HEART; document.body.appendChild(f);
    var a = f.animate([
      { transform: "translate(" + (sx - OFF) + "px," + (sy - OFF) + "px) scale(1)", opacity: 1 },
      { transform: "translate(" + (mx - OFF) + "px," + (my - OFF) + "px) scale(1.18)", opacity: 1, offset: .5 },
      { transform: "translate(" + (ex - OFF) + "px," + (ey - OFF) + "px) scale(.4)", opacity: .5 }
    ], { duration: dur, easing: "cubic-bezier(.5,.02,.5,1)", fill: "forwards" });
    a.onfinish = function () { f.remove(); if (onLand) onLand(); };
  }
  function flyToIcon(s, onLand) {
    var link = navLink();
    if (!iconVisible(link)) { if (onLand) onLand(); return; }    // mobile: no visible icon -> skip flight
    var t = centerOf(link);
    flyArc(s.x, s.y, t.x, t.y, 700, onLand);
  }
  /* reverse flight: from the header icon back DOWN to the card (fallback: drop below the icon) */
  function reverseFlight(toBtn, onLand) {
    var link = navLink();
    if (!iconVisible(link)) { if (onLand) onLand(); return; }
    var from = centerOf(link), to = null;
    if (toBtn && toBtn.isConnected) { var r = toBtn.getBoundingClientRect(); if (inView(r)) to = { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
    if (!to) to = { x: from.x, y: Math.min(window.innerHeight - 90, from.y + 170) };
    flyArc(from.x, from.y, to.x, to.y, 640, onLand);
  }

  /* ---------- toast ---------- */
  function ensureWrap() {
    if (wrap && document.body.contains(wrap)) return wrap;
    wrap = document.createElement("div"); wrap.className = "awt-wrap"; wrap.setAttribute("aria-live", "polite");
    document.body.appendChild(wrap); return wrap;
  }
  function dismiss(el) {
    if (!el || el.classList.contains("out")) return;
    clearTimeout(timer); el.classList.remove("in"); el.classList.add("out");
    el.addEventListener("animationend", function h(e) { if (e.target === el && e.animationName === "awt-out") { el.removeEventListener("animationend", h); el.remove(); } });
  }
  function showToast(p, sourceBtn, onUndo, noFlight) {
    var w = ensureWrap();
    Array.prototype.forEach.call(w.children, dismiss);
    var guest = (navLink() && navLink().dataset.awtGuest === "1");
    var el = document.createElement("div"); el.className = "awt";
    var thumb = p.img ? '<img src="' + esc(p.img) + '" alt="">' : '<svg class="ph" viewBox="0 0 24 24"><path d="M20 7 12 3 4 7v10l8 4 8-4z"/><path d="m4 7 8 4 8-4M12 11v10"/></svg>';
    var finRow = p.fin ? '<div class="awt-fin"><span class="sw"' + (p.swatchBg && p.swatchBg !== "none" ? ' style="background-image:' + p.swatchBg + '"' : '') + '></span>' + esc(p.fin) + '</div>' : '';
    el.innerHTML =
      '<button class="awt-x" aria-label="Dismiss">✕</button>'
      + '<div class="awt-main"><span class="awt-im">' + thumb + '<span class="awt-heart">' + HEART + '</span></span>'
      + '<div class="awt-tx"><div class="awt-tt">Added to wishlist</div>'
      + (p.title ? '<div class="awt-nm">' + esc(p.title) + '</div>' : '') + finRow + '</div></div>'
      + '<div class="awt-foot"><a class="awt-view" href="/pages/wishlist">' + HEART + 'View wishlist</a>'
      + '<button class="awt-undo" type="button"><svg viewBox="0 0 24 24"><path d="M9 14 4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-1"/></svg>Undo</button></div>'
      + (guest ? '<div class="awt-nudge"><a href="/account/login">Log in</a> to keep it across devices</div>' : '')
      + '<div class="awt-prog"><i></i></div>';
    w.appendChild(el); void el.offsetWidth; el.classList.add("in");
    el.querySelector(".awt-x").addEventListener("click", function () { dismiss(el); });
    el.querySelector(".awt-undo").addEventListener("click", function () {
      dismiss(el); undo(p, sourceBtn, noFlight);
      if (onUndo) { try { onUndo(); } catch (e) {} } // caller resets its own UI (e.g. the bloom's Wishlist button)
    });
    timer = setTimeout(function () { dismiss(el); }, 5000);
  }

  /* ---------- undo (reverse flight + real removal) ---------- */
  function undo(p, sourceBtn, noFlight) {
    lastOp = { adding: false, t: Date.now() };            // dedupe the resulting st-deleted event
    lastFire = Date.now();
    bumpBadge(-1);                                          // heart leaves the icon
    var land = function () { if (sourceBtn && sourceBtn.isConnected) sourceBtn.classList.remove("st-is-added"); };
    if (noFlight) land(); else reverseFlight(sourceBtn, land);
    try { if (p.handle && window.SWishlist) window.SWishlist.removeFromWishlist(p.handle); } catch (e) {}
  }

  /* ---------- click: optimistic add / reverse-flight remove ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest(".st-wishlist-button, [class*='wishlist-button'], [class*='wishlist_button']") : null;
    if (!btn) return;
    var adding = !(btn.classList.contains("st-is-added") || btn.classList.contains("st-added") || btn.getAttribute("aria-pressed") === "true");
    var s = centerOf(btn), product = productFromHeart(btn);
    lastOp = { adding: adding, t: Date.now() }; lastFire = Date.now(); lastBadgeOp = Date.now();   // guard onCount through the flight
    if (adding) {
      btn.classList.add("st-is-added");                    // optimistic fill (SWishlist confirms the same state a beat later)
      firePulse(s.x, s.y);
      flyToIcon(s, function () { bumpBadge(1); showToast(product, btn); });   // commit feel on LAND
    } else {
      /* un-heart: SWishlist handles the real remove on this click; we do the reverse flight
         and only un-fill when it lands (button stays filled during the flight). */
      bumpBadge(-1);
      reverseFlight(btn, function () { if (btn.isConnected) btn.classList.remove("st-is-added"); });
    }
  }, true);

  /* ---------- SWishlist events: dedupe what we already showed, reconcile the count ---------- */
  function handledByClick(adding) { return !!(lastOp && Date.now() - lastOp.t < 6000 && lastOp.adding === adding); }
  function onAdd() { if (handledByClick(true)) return; if (Date.now() - lastFire < 600) return; lastFire = Date.now(); bumpBadge(1); }
  function onDel() { if (handledByClick(false)) return; if (Date.now() - lastFire < 600) return; lastFire = Date.now(); bumpBadge(-1); }
  function onCount(e) {
    if (Date.now() - lastBadgeOp < 1500) return;            // don't fight a recent optimistic op
    if (e && e.detail && typeof e.detail.count === "number") setBadge(e.detail.count);
  }
  ["swishlist:st-added-product", "swishlist:st-added-wishlist", "st-added-product"].forEach(function (n) { document.addEventListener(n, onAdd); window.addEventListener(n, onAdd); });
  ["swishlist:st-deleted-product", "swishlist:st-deleted-wishlist", "st-deleted-product"].forEach(function (n) { document.addEventListener(n, onDel); window.addEventListener(n, onDel); });
  ["SWishlistLoaderDataReady", "swishlist:SWishlistLoaderDataReady", "swishlist:st-updated-wishlist", "st-updated-wishlist"].forEach(function (n) { document.addEventListener(n, onCount); window.addEventListener(n, onCount); });

  whenReady(function () { initBadge(); });

  /* ---------- shared reward API ----------
     Lets other components fire the SAME add language - pulse + heart flight +
     badge-on-land + Undo toast - through this engine, keeping its dedupe and
     reconcile guards intact (the SWishlist added event that follows an API add
     is swallowed by lastOp exactly like a click-path add). First consumer: the
     finish-bloom committed modal's Wishlist button (atelier-finish-bloom.js).
     rewardAdd opts:    { x, y      - flight/pulse origin (viewport px)
             product         - { title, img, fin, swatchBg, handle } for the toast
             sourceBtn       - element the Undo reverse-flight returns to
             onUndo          - callback after Undo's removeFromWishlist
             noFlight        - true when the caller's surface COVERS the header
                               icon (e.g. the PDP lightbox): skip the heart
                               flight (it would fly to an occluded target),
                               keep pulse + badge + toast; Undo also skips its
                               reverse flight and un-fills instantly }
     rewardRemove opts: { sourceBtn - element the reverse flight lands on
             onLand          - callback on landing (caller un-fills its UI THEN,
                               matching the card un-heart: filled during flight)
             noFlight        - as above: skip the flight, onLand fires at once }
     NB: the CALLER makes the actual add/removeFromWishlist API call. */
  window.AtelierWishlistFX = {
    rewardAdd: function (opts) {
      opts = opts || {};
      var p = opts.product || {};
      lastOp = { adding: true, t: Date.now() }; lastFire = Date.now(); lastBadgeOp = Date.now();
      if (opts.x != null && opts.y != null) firePulse(opts.x, opts.y);
      var land = function () {
        bumpBadge(1);
        showToast(p, opts.sourceBtn || null, opts.onUndo, !!opts.noFlight);
      };
      if (opts.noFlight) land();
      else flyToIcon({ x: opts.x || 0, y: opts.y || 0 }, land);
    },
    rewardRemove: function (opts) {
      opts = opts || {};
      lastOp = { adding: false, t: Date.now() }; lastFire = Date.now(); lastBadgeOp = Date.now();
      if (wrap) Array.prototype.forEach.call(wrap.children, dismiss); // a lingering add-toast's Undo is now stale
      bumpBadge(-1);
      if (opts.noFlight) { if (opts.onLand) opts.onLand(); return; }
      reverseFlight(opts.sourceBtn || null, opts.onLand || null);
    }
  };
})();
